import Layout from '..'
import Main from '@/layouts/main'
import TopBar from '@/sections/repeatable/vacancy-detail/top-bar'
import LoaderSectionVacancyDetail from '@/sections/repeatable/vacancy-detail/loader'
import { VacancyDetail } from '@/interfaces/vacancy'
import StructuredDataJob from '@/components/structured-data-job'
import Vacancy from '@/sections/repeatable/vacancy-detail/detail'

const VacancyDetailPageLayout = ({ data }: { data: VacancyDetail }) => (
  <Layout>
    <StructuredDataJob vacancy={data} />
    <Main>
      <TopBar />
      {data ? <Vacancy vacancy={data} /> : <LoaderSectionVacancyDetail />}
    </Main>
  </Layout>
)

export default VacancyDetailPageLayout
